import { ApiOutlined, MailOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
const darkCardStyle = {
    background: "#21262c",
    border: "1px solid #21262c",
    color: "#ffffff",
};


const CommunicationModuleDark = () => {

    const navigate = useNavigate();
    return (
        <div
            style={{
                padding: 24,
                background: "#11161c",
                minHeight: "100vh",
            }}
        >
            {/* Parent Menu */}
            <Card
                style={{ ...darkCardStyle, marginBottom: 24 }}
                title={
                    <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#fff" }}>
                        <ApiOutlined style={{ color: "#6e7afb" }} />
                        <span>Communication Module</span>
                    </div>
                }
                headStyle={{ borderBottom: "1px solid #21262c" }}
            />


            {/* Sub Menu Sections */}
         <Row gutter={[24, 24]} align="stretch">
  {/* Bulk Email */}
  <Col xs={24} md={12} style={{ display: "flex" }}>
    <Card
      hoverable
      style={{
        ...darkCardStyle,
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
      headStyle={{ borderBottom: "1px solid #21262c" }}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#fff" }}>
          <MailOutlined style={{ color: "#1a865f" }} />
          <span>Bulk Email</span>
        </div>
      }
    >
      <p style={{ color: "#c7cace" }}>
        Send announcements, alerts, and notifications to users across
        selected networks.
      </p>

      {/* Push button to bottom */}
      <div style={{ marginTop: "auto" }}>
        <Button type="primary" onClick={() => navigate("bulk-email")}>
          Manage Bulk Emails
        </Button>
      </div>
    </Card>
  </Col>

  {/* SAP BA Communication */}
  <Col xs={24} md={12} style={{ display: "flex" }}>
    <Card
      hoverable
      style={{
        ...darkCardStyle,
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
      headStyle={{ borderBottom: "1px solid #21262c" }}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#fff" }}>
          <ApiOutlined style={{ color: "#9254de" }} />
          <span>SAP BA Communication</span>
        </div>
      }
    >
      <p style={{ color: "#c7cace" }}>
        Configure and manage SAP Business Application communication
        workflows and integrations.
      </p>

      {/* Push button to bottom */}
      <div style={{ marginTop: "auto" }}>
        <Button type="dashed" onClick={()=>{
          navigate("BAcommunication")
        }}style={{ background: "#21262c", color: "#fff" }}>
          Open SAP BA Communication
        </Button>
      </div>
    </Card>
  </Col>
</Row>
        </div>
    );
};


export default CommunicationModuleDark;